import { render, staticRenderFns } from "./CreateSubUserModal.vue?vue&type=template&id=3a297404&"
import script from "./CreateSubUserModal.vue?vue&type=script&lang=js&"
export * from "./CreateSubUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports